import { createContext, useContext } from 'react';
import { UserRole } from '../types/domain';

export type RolesContextType = {
  roles: UserRole[];
  hasRole: (role: UserRole) => boolean;
  isLoading: boolean;
  error: string | null;
  clearCache: () => void;
};

export const RolesContext = createContext<RolesContextType | undefined>(undefined);

export const useRoles = (): RolesContextType => {
  const context = useContext(RolesContext);
  if (!context) {
    throw new Error('useRoles must be used within a RolesProvider');
  }
  return context;
};
